export default "__VITE_ASSET__DiouW5t___"